export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p><strong>Резиновый коврик</strong> - это классический прямоугольный коврик 19.5x23.5x0.3см c эффектом прилипания к рабочей поверхности. Материал – пористая резина, покрытая тканью для нанесения качественных полноценных изображений.</p>
        <p><strong>Пластиковый коврик Slim</strong> - это тонкий и практичный коврик, который идеально подходит для дома и офиса. Специальная основа из вспененного ПВХ не дает скользить ему на любой поверхности, создавая эффект "прилипания" к столу.</p>
        <p>Верхнее антибликовое пластиковое покрытие придаёт дополнительную яркость изображению.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <p><strong>Резиновый коврик</strong> - перенос изображения осуществляется методом сублимации (термопереноса). Высокое качество покрытия создаёт яркое и сочное изображение. Оно как бы «приваривается» к поверхности, что обеспечивает его износостойкость и яркость красок. Наша продукция проверяется на герметичность.</p>
        <p><strong>Пластиковый коврик Slim</strong> - изображение наносится на полиграфическую вкладку, которая далее запаивается по периметру в пластик, благодаря этому коврик становится стойким к воздействию влаги. Можно протирать влажной тканью. Технология - запайка.</p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
